import React from 'react';
import Header from "../header/Header";
import Footer from "../footer/Footer";
import './apartments-search-pege.css'
import {MDBIcon} from "mdbreact";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

const ApartmentSearchPage = () => {
    return(
        <>
            <Header/>

            <div className="apartments-search-wrapper">
            <section className="head-apartments-search search-sec">
                <form action="#" method="post" noValidate="novalidate">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-sm-12 p-0">
                                <input type="text" className="form-control search-slt"
                                       placeholder="Enter Pickup City"/>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 p-0">
                                <input type="text" className="form-control search-slt"
                                       placeholder="Enter Drop City"/>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 p-0">
                                <select className="form-control search-slt" id="exampleFormControlSelect1">
                                    <option>Select Vehicle</option>
                                    <option>Example one</option>
                                    <option>Example one</option>
                                    <option>Example one</option>
                                    <option>Example one</option>
                                    <option>Example one</option>
                                    <option>Example one</option>
                                </select>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-12 p-0">
                                <button type="button" className="btn btn-danger wrn-btn">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            </section>
                <MDBIcon icon="align-justify" size="lg"/>
                <MDBIcon icon="grip-vertical" size="lg"/>
                <MDBIcon icon="list" size="lg"/>
                <MDBIcon icon="sort-alpha-up-alt" size="lg"/>
                <MDBIcon icon="sort-alpha-up" size="lg"/>
                <MDBIcon icon="sort-amount-down-alt" size="lg"/>
                <MDBIcon icon="sort-amount-down" size="lg"/>
            <div className="container-fluid col-md-12">
                <div className="row">
                    <div className="col col-12 col-md-6 col-xl-6 listing-block">
                        <div className="media">
                            <div className="fav-box"><i className="fa fa-heart-o" aria-hidden="true"></i>
                            </div>
                            <img className="d-flex align-self-start"
                                 src="https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?h=350&auto=compress&cs=tinysrgb"
                                 alt="Generic placeholder image"/>
                            <div className="media-body pl-3">
                                <div className="price">$506,400<small>New York</small></div>
                                <div className="stats">
                                    <span><i className="fa fa-arrows-alt"></i>1678 Sq ft</span>
                                    <span><i className="fa fa-bath"></i>2 Beadrooms</span>
                                </div>
                                <div className="address">4062 Walnut Hill Drive
                                    Cincinnati
                                </div>
                            </div>
                        </div>
                        <div className="media">
                            <div className="fav-box"><i className="fa fa-heart-o" aria-hidden="true"></i>
                            </div>
                            <img className="d-flex align-self-start"
                                 src="https://images.pexels.com/photos/358636/pexels-photo-358636.jpeg?h=350&auto=compress&cs=tinysrgb"
                                 alt="Generic placeholder image"/>
                            <div className="media-body pl-3">
                                <div className="price">$506,400<small>New York</small></div>
                                <div className="stats">
                                    <span><i className="fa fa-arrows-alt"></i>1678 Sq ft</span>
                                    <span><i className="fa fa-bath"></i>2 Beadrooms</span>
                                </div>
                                <div className="address">4062 Walnut Hill Drive
                                    Cincinnati
                                </div>
                            </div>
                        </div>
                        <div className="media">
                            <div className="fav-box"><i className="fa fa-heart-o" aria-hidden="true"></i>
                            </div>
                            <img className="d-flex align-self-start"
                                 src="https://images.pexels.com/photos/186077/pexels-photo-186077.jpeg?h=350&auto=compress&cs=tinysrgb"
                                 alt="Generic placeholder image"/>
                            <div className="media-body pl-3">
                                <div className="price">$799,000<small>New York</small></div>
                                <div className="stats">
                                    <span><i className="fa fa-arrows-alt"></i>1678 Sq ft</span>
                                    <span><i className="fa fa-bath"></i>2 Beadrooms</span>
                                </div>
                                <div className="address">4062 Walnut Hill Drive
                                    Cincinnati
                                </div>
                            </div>
                        </div>
                        <div className="media">
                            <div className="fav-box"><i className="fa fa-heart-o" aria-hidden="true"></i>
                            </div>
                            <img className="d-flex align-self-start"
                                 src="https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?h=350&auto=compress&cs=tinysrgb"
                                 alt="Generic placeholder image"/>
                            <div className="media-body pl-3">
                                <div className="price">$506,400<small>New York</small></div>
                                <div className="stats">
                                    <span><i className="fa fa-arrows-alt"></i>1678 Sq ft</span>
                                    <span><i className="fa fa-bath"></i>2 Beadrooms</span>
                                </div>
                                <div className="address">4062 Walnut Hill Drive
                                    Cincinnati
                                </div>
                            </div>
                        </div>
                        <div className="media">
                            <div className="fav-box"><i className="fa fa-heart-o" aria-hidden="true"></i>
                            </div>
                            <img className="d-flex align-self-start"
                                 src="https://images.pexels.com/photos/358636/pexels-photo-358636.jpeg?h=350&auto=compress&cs=tinysrgb"
                                 alt="Generic placeholder image"/>
                            <div className="media-body pl-3">
                                <div className="price">$506,400<small>New York</small></div>
                                <div className="stats">
                                    <span><i className="fa fa-arrows-alt"></i>1678 Sq ft</span>
                                    <span><i className="fa fa-bath"></i>2 Beadrooms</span>
                                </div>
                                <div className="address">4062 Walnut Hill Drive
                                    Cincinnati
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col col-12 col-md-6 col-xl-6 map-box mx-0 px-0">
                        <iframe width="100%" height="600" frameBorder="0" scrolling="no" marginHeight="0"
                                marginWidth="0"
                                src="https://maps.google.co.uk/maps?f=q&source=s_q&hl=en&geocode=&815&sspn=8.047465,13.666992&ie=UTF8&hq=&hnear=15+Springfield+Way,+Hythe+CT21+5SH,+United+Kingdom&t=m&z=14&ll=51.077429,1.121722&output=embed"></iframe>
                    </div>
                </div>
            </div>
            </div>
            <Footer/>
            </>
    )
};
export default ApartmentSearchPage;
